export class TipoServico{
    tipoServicoID: number;
    codigo: string;
    descricao: string;
    exibePortal: number;
    flagVas: string;
    tipoServico: string;
}
